import useAxiosInterceptor from 'src/services/interceptor';
import { automaticBillingHoldApiPaths } from '../constants';

class AutomaticBillingHoldService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  /** The interceptor adds the Facility_id header, so the verdict is for the logged-in facility. */
  getStatus = () => {
    return this.axiosInstance.get(automaticBillingHoldApiPaths.status);
  };
}

const automaticBillingHoldService = new AutomaticBillingHoldService();

export default automaticBillingHoldService;
